module.exports = __webpack_public_path__ + "static/media/gh-map-mobile.c1eb9722.png";